import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { DropdownButton, MenuItem, Button } from 'react-bootstrap';

import * as Actions from '../../redux/actions';
import Safe from '../Components/Safe';
import Loading from '../Components/Loading';
import DataGrid from '../Components/DataGrid';

const FLYOVER_ID = 'primary-sensor';

class SensorsPageView extends Component {
  constructor(props) {
    super(props);

    this.fetch = this.fetch.bind(this);
    this.viewSensorDetail = this.viewSensorDetail.bind(this);
    this.deleteSensor = this.deleteSensor.bind(this);
    this.closeSensorDetail = this.closeSensorDetail.bind(this);
  }

  componentDidMount() {
    this.fetch();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.orgId !== this.props.orgId) {
      this.fetch();
    }
  }

  // Make sure any flyovers belonging to this page are closed when navigating away
  componentWillUnmount() {
    this.closeSensorDetail();
  }

  deleteSensor(sensor) {
    const { dispatch, orgId } = this.props;
    if (_.isEmpty(sensor) || _.isNil(sensor.id)) {
      console.warn('Unexpected attempt to delete empty sensor or sensor with no id: ', sensor);
      return;
    }

    dispatch(Actions.Page.deleteSensor(orgId, sensor.id));
  }

  fetch() {
    const { dispatch, meta, orgId } = this.props;
    dispatch(Actions.Page.fetchSensors(orgId, meta));
  }

  viewSensorDetail(sensor) {
    const { dispatch, orgId } = this.props;
    // If it's empty, then we want to make a new Sensor
    if (_.isEmpty(sensor)) {
      dispatch(Actions.Detail.presentSensorCreate(orgId, FLYOVER_ID));
    } else {
      // Otherwise, we want to present this sensor's details in the flyout
      dispatch(Actions.Detail.presentSensorEdit(orgId, sensor.id, FLYOVER_ID));
    }
  }

  closeSensorDetail() {
    const { dispatch } = this.props;
    dispatch(Actions.Detail.dismiss(FLYOVER_ID));
  }

  render() {
    const {
      loading = false,
      data = {},
      meta = {},
      user = {},
      payload = {},
    } = this.props;

    const {
      role, // eslint-disable-line
    } = user;

    const {
      toplevel,
      secondlevel,
    } = payload;

    const {
      sensors = [],
    } = data;

    const sensorsMeta = meta.sensors || {};

    let loadingStyles = {};
    if (loading && _.isEmpty(sensorsMeta)) {
      loadingStyles = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: '100%',
        marginTop: '50px',
      };
    }

    return (
      <span
        className='dashboard'
        style={{ ...loadingStyles }}
      >
        {loading && _.isEmpty(sensorsMeta) &&
          <Loading />
        }
        {(!loading || !_.isEmpty(sensorsMeta)) &&
          <div style={{ position: 'relative' }}>
            <div className='page-header'>
              <span>
                <span className='page-title' style={{ marginRight: '5px' }}>
                  <h1>
                    <Safe
                      render
                      safe
                      path={`pages.${toplevel}.${secondlevel}`}
                      value='Sensor Management'
                    />
                  </h1>
                </span>
                <span className='page-description' style={{ fontSize: '0.6rem', marginTop: '5px' }}>
                  <p>| &nbsp;
                    <Safe
                      render
                      safe
                      path={`pages.${toplevel}.${secondlevel}`}
                      value='Add, remove, monitor, or add new capabilities to your Sensors.'
                    />
                  </p>
                </span>
              </span>
              <span
                style={{
                  fontSize: '0.6rem',
                  marginTop: '5px',
                }}
              >
                <Button
                  bsStyle='primary'
                  bsSize='small'
                  onClick={() => {
                    this.viewSensorDetail({});
                  }}
                >
                  Add New Sensor
                </Button>
              </span>
            </div>
            <hr />
            <div className='row main-content' style={{ marginTop: '15px' }}>
              <span style={{
                marginLeft: 'auto',
                marginRight: '15px',
                marginTop: '-15px',
                lineHeight: '20px',
                fontSize: '14px',
              }}
              >
                Total number of sensors: {sensors.length}
              </span>
              <div className='col-12 left-column'>
                <div className='column-content'>
                  <DataGrid
                    columnHeaders='sensorsHeaders'
                    data={sensors}
                    getTdProps={(state, rowInfo) => ({
                      onClick: (e, handleOriginal) => {
                        this.viewSensorDetail(rowInfo.original);
                        if (handleOriginal) {
                          handleOriginal();
                        }
                      },
                      style: {
                        cursor: 'pointer',
                      },
                    })}
                    columns={[
                      {
                        id: 'connected',
                        filterable: false,
                        width: 150,
                        Cell: row => (
                          <div>{`${row.original.health.status === 'connected'}`}</div>
                        ),
                      }, {
                        accessor: 'name',
                        filterable: false,
                      }, {
                        id: 'actions',
                        sortable: false,
                        filterable: false,
                        width: 40,
                        Cell: row => (
                          <div style={{ position: 'absolute' }}>
                            <DropdownButton
                              noCaret
                              pullRight
                              title={
                                <i
                                  style={{ padding: '10px' }}
                                  className='fas fa-ellipsis-v'
                                />
                            }
                              id={`actions-dropdown-${row.original.id}`}
                              ref={(c) => { this.orgMenu = c; }}
                              onClick={(e) => {
                                e.stopPropagation();
                              }}
                            >
                              <MenuItem
                                eventKey={0}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  this.viewSensorDetail(row.original);
                                  document.dispatchEvent(new MouseEvent('click'));
                                }}
                              >
                              View Detail
                              </MenuItem>
                              <MenuItem
                                eventKey={0}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  this.deleteSensor(row.original, true);
                                  // @XXX: this is suspicious
                                  document.dispatchEvent(new MouseEvent('click'));
                                }}
                              >
                              Delete
                              </MenuItem>
                            </DropdownButton>
                          </div>
                        ),
                      }]}
                  />
                </div>
              </div>
            </div>
          </div>
        }
      </span>
    );
  }
}

SensorsPageView.propTypes = {
  orgId: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired,
  data: PropTypes.shape({}),
  meta: PropTypes.shape({}),
  user: PropTypes.shape({}),
  payload: PropTypes.shape({}),
  // applyFilter: PropTypes.func.isRequired,
  // filters: PropTypes.shape({}),
  loading: PropTypes.bool,
};

SensorsPageView.defaultProps = {
  user: {},
  payload: {},
  data: {},
  meta: {},
  // filters: {},
  loading: false,
};

export default SensorsPageView;



// WEBPACK FOOTER //
// ./src/views/Pages/SensorsPageView.js